export const PaymentMethods = {
  ALL: "all",
  PAYPAL: "paypal",
  STRIPE: "stripe",
  PAYSAFE: "paysafe",
  PAYONEER: "payoneer",
  COIN: "coin",
};

export const BannerConstants = {
  MAINTENANCE: "maintenance",
  STATIC: "static",
  REDEEM: "redeem",
  DISCOUNT: "discount",
  TRADE: "trade",
};

export const APP_MODULES = {
  USER: "user",
  SELLER: "seller",
  RATING: "rating",
  PAGE: "page",
  FAQ: "faq",
  DISPUTE_CONVERSATION: "disputeConv",
  DISPUTE: "dispute",
  AD: "ad",
  COMMON: "common",
  TRANSACTION: "transaction",
  INVENTORY: "inventory",
  ROLES: "roles",
  PERMISSION: "permission",
  NOTIFICATION: "notification",
  OFFER: "offer",
  CART: "cart",
  INSURANCE: "insurance",
  BANNER: "banner",
  RULES_REGULATION: "rulesRegulation",
  PAY_METHOD: "payMethod",
  ORDER: "order",
  BOOSTER_PLAN: "boosterPlan",
  BUY_OFFER: "buyOffer",
  FOLLOW: "follow",
  CHAT: "chat",
  SUPPORT: "support",
  SERVICE_CHARGE: "serviceCharge",
  TRADE: "trade",
  WITHDRAW: "withdraw",
  DISPUTE_REPLICA: "disputeReplica",
  DISPUTE_RATING: "disputeRating",
};

export const REFRESH_ACTIONS = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  STATUS_UPDATE: "statusUpdate",
};
